module.exports = __webpack_public_path__ + "img/NHWBCarousel_work.ce021bdd.webp";